import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/Rank";
import Order from "./pages/Order";
import "./assets/styles/custom.css";
import { navigation_data } from "./core/navigation";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";


function App() {
  return (
    <AuthProvider>
      <Router>
        <AppWrapper />
      </Router>
    </AuthProvider>
  );
}

function AppWrapper() {
  const location = useLocation();
  let theme = "theme-light"; // theme-dark, theme-light
  // console.log("location ", window.location.pathname);

  const hideNavbarPaths = ["/sign-in", "/sign-up"];
  const shouldShowNavbar = !hideNavbarPaths.includes(location.pathname);

  return (
    <div id="page" className={theme}>
      {shouldShowNavbar && <Navbar />}

      <Routes>
          {navigation_data.map((item, index) => (
            item.protected ? (
              <Route
                key={index}
                path={item.path}
                element={
                  <PrivateRoute>{item.component}</PrivateRoute>
                }
              />
            ) : (
              <Route key={index} path={item.path} element={item.component} />
            )
          ))}

        {/* {navigation_data.map((item, index) => (
          <Route key={index} path={item.path} element={item.component} />
        ))} */}

        {/* <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/order" element={<Order />} /> */}
      </Routes>
    </div>
  );
}

export default App;
